import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openFinanceSlideout } from '../../actions/lister-actions';

const InterestFreeCreditButton = ({
	financePromotion,
	classes,
	fullTitle,
	NowPrice,
	MemberPrice,
	Code,
	ColourId,
	financePromotions,
	State,
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false,
	},
	Switch24Pricing,
	representativeAprRateString,
	purchaseAprRateString,
}) => {
	const dispatch = useDispatch();

	const { AnnualMembershipFee, UseSwitch24, UseUpfrontPricingAmount } =
		useSelector((state) => state.featureSwitches);

	const slideoutPayload = {
		productId: ColourId,
		productSku: Code,
		nowPrice: NowPrice,
		memberPrice: MemberPrice,
		annualMembershipFee: AnnualMembershipFee,
		financePromotionCodes: financePromotions
			? financePromotions.map((p) => p.PromotionCode)
			: [],
		isInStock: State !== 'OutOfStock',
		memberUpfrontPaymentAmount: UpfrontPricing?.MemberUpfrontPaymentAmount,
		upfrontPaymentAmount: UpfrontPricing?.UpfrontPaymentAmount,
		upfrontPaymentPercentage: UpfrontPricing?.UpfrontPaymentPercentage,
		upfrontPaymentsEnabled: UseUpfrontPricingAmount,
		switch24Pricing: Switch24Pricing,
		isSwitch24Enabled: UseSwitch24,
		representativeAprRateString,
		purchaseAprRateString,
	};

	const openFinanceSlideoutWithPayload = () => {
		dispatch(openFinanceSlideout(slideoutPayload));
	};

	return (
		<button
			type="button"
			aria-label="Interest Free Finance Promotion"
			className={`${classes} relative z-10 p-0 w-full mt-2 lg:mt-4 bg-transparent`}
			onClick={openFinanceSlideoutWithPayload}
			data-tag-name="finance-interest-free-button"
			data-tag-finance-type="finance-interest-free-button"
			data-tag-product={fullTitle}
			data-testid="finance-interest-free">
			<div className="flex flex-row items-center bg-steam p-1 rounded-sm text-title-sm text-xs">
				<span className="px-2 flex-grow">
					{`${financePromotion.PromotionMonths} months 0% interest available`}
				</span>
				<i className="ico ico-chevron-right text-xl text-cta-action" />
			</div>
		</button>
	);
};

export default InterestFreeCreditButton;
